/**
 * Power Distribution per-instance editor — placeholders for the 6 power distribution
 * fields (#996 — Facility Power / Power Distribution).
 * Mirrors largeUpsRequirementsUi (placeholder-only; power distribution has no
 * per-instance dropdown option lists). Placeholder text reuses labels already shown in
 * the live Facility Power / Power Distribution card.
 */

export const POWER_DISTRIBUTION_PLACEHOLDERS = {
  upsOutputVoltage: 'Enter UPS output voltage',
  distributionVoltageToLoad: 'Enter IT load voltage',
  overheadBuswayOrUnderFloor: 'Enter overhead busway or under floor',
  buswayAmperage: 'Enter busway amperage',
  buswayLengthFt: 'Enter busway length (ft)',
  tapOfBoxRequirements: 'Enter tap off box requirements',
} as const;
